import { render, staticRenderFns } from "./PatientInvoicesDetail.vue?vue&type=template&id=9691d0ec&scoped=true"
import script from "./PatientInvoicesDetail.vue?vue&type=script&lang=js"
export * from "./PatientInvoicesDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientInvoicesDetail.vue?vue&type=style&index=0&id=9691d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9691d0ec",
  null
  
)

export default component.exports